import React from "react";

import { FlattenedPlanData } from "../../../hooks/useWellnessPlans";
import WellnesPlanServices from "./WellnesPlanServices";
import WellnessPlanDetailsHeader from "./WellnessPlanDetailsHeader";

interface IWellnessPlanDetails {
  selectedPlan: string;
  planData: FlattenedPlanData | null;
  petName: string;
}

const WellnessPlanDetails = ({
  selectedPlan,
  planData,
  petName,
}: IWellnessPlanDetails) => {
  if (!planData) return null;

  return (
    <div className="flex flex-col w-full rounded-xl border border-violet-6 bg-white overflow-hidden">
      <WellnessPlanDetailsHeader
        planData={planData}
        petName={petName}
      />
      <div className="px-4 pt-3 pb-4">
        <WellnesPlanServices planType={selectedPlan} planData={planData} fromAllPlans={true} />
      </div>
    </div>
  );
};

export default WellnessPlanDetails;
